import React from 'react';
import PropTypes from 'prop-types';

import Slot from '../Slot';
import { Layout } from '../styles';

const SpaceDetails = ({ slot }) => {
	const { type, data, layout } = slot[0];

	return (
		<Layout>
			<Slot
				top={5}
				left={5}
				width={90}
				height={52.5}
				component={type}
				data={data}
				layout={layout}
			/>
			<Slot
				top={62.5}
				left={5}
				width={42.5}
				height={32.5}
				component={type}
				data={data}
				layout={layout}
			/>
			<Slot
				top={62.5}
				left={52.5}
				width={42.5}
				height={32.5}
				component={type}
				data={data}
				layout={layout}
			/>
		</Layout>
	)
}

SpaceDetails.defaultProps = {
	slot: []
}

SpaceDetails.propTypes = {
	slot: PropTypes.array,
}

export default SpaceDetails
